const POLL_INTERVAL_MS = 60_000;
const MAXIMUM_RELOAD_DELAY_MS = 30_000;

function fingerprintOf(html: string): number {
  let fingerprint = html.length;
  for (let index = 0; index < html.length; index++) {
    fingerprint = (fingerprint * 31 + html.charCodeAt(index)) | 0;
  }

  return fingerprint;
}

async function readServedShell(): Promise<number | null> {
  const response = await fetch('/index.html', { cache: 'no-store' });
  if (!response.ok) {
    return null;
  }

  return fingerprintOf(await response.text());
}

export function startDeploymentWatchdog(): void {
  let shellServedAtStartup: number | null = null;
  let reloadScheduled = false;

  async function reloadWhenANewerShellIsDeployed(): Promise<void> {
    if (reloadScheduled) {
      return;
    }

    let servedShell: number | null;
    try {
      servedShell = await readServedShell();
    } catch {
      return;
    }

    if (servedShell === null) {
      return;
    }

    if (shellServedAtStartup === null) {
      shellServedAtStartup = servedShell;
      return;
    }

    if (servedShell === shellServedAtStartup) {
      return;
    }

    reloadScheduled = true;
    console.info('[shell] A newer Portal is deployed, reloading this tab.');
    window.setTimeout(() => {
      window.location.reload();
    }, Math.random() * MAXIMUM_RELOAD_DELAY_MS);
  }

  void reloadWhenANewerShellIsDeployed();
  window.setInterval(() => void reloadWhenANewerShellIsDeployed(), POLL_INTERVAL_MS);
}
